import { c as _c } from "react/compiler-runtime";
import Link, { LinkStyle, LinkType } from "@/components/common/link/link";
import { CtaStrip } from "@/sanity/sanity.types";
import css from "./home-cta-strip.module.scss";
import GridRow from "@/components/common/grid-row/grid-row";
import GridColumn from "@/components/common/grid-column/grid-column";
interface IHomeCTAStripProps {
  data: CtaStrip;
}
const HomeCTAStrip = props => {
  const $ = _c(10);
  const {
    data
  } = props;
  const {
    heading,
    buttons
  } = data;
  let t0;
  if ($[0] !== heading) {
    t0 = <h2 className={`${css.homeCTAStripHeader} mb-12 md:mb-8`}>{heading}</h2>;
    $[0] = heading;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = `grid grid-cols-1 md:grid-cols-${buttons?.length} gap-6 lg:px-[12%]`;
  let t2;
  if ($[2] !== buttons) {
    t2 = buttons?.map(_temp);
    $[2] = buttons;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t3) {
    t4 = <div className={css.homeCTAStrip}><GridRow className={css.homeCTAStripRow}><GridColumn className={css.homeCTAStripColumn}>{t0}{t3}</GridColumn></GridRow></div>;
    $[7] = t0;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default HomeCTAStrip;
function _temp(button, index) {
  return <Link key={index} href={button.link?.href ?? ""} linkType={LinkType.BUTTON} linkStyle={LinkStyle.SECONDARY} className="!w-full whitespace-nowrap" data-cta-id={button?.link?.ctaId ?? ""} data-cta-value={button?.link?.ctaValue ?? ""} rel={button?.link?.nofollow}>{button.link?.label}</Link>;
}